var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTicketSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4068 7.96635L23.0588 19.6555C25.1151 18.8697 27.5629 19.3607 29.3256 21.0306C31.0881 22.7987 31.4797 25.4509 30.4028 27.6117L26.6821 23.7808C24.8216 21.9144 21.982 24.763 23.8424 26.6295L27.6612 30.4604C25.5071 31.4426 22.8633 31.0498 21.101 29.2817C19.3385 27.6117 18.9469 25.0579 19.7302 22.995L8.07815 11.3058C6.02187 12.0916 3.47609 11.6988 1.81137 9.93069C0.0488986 8.16261 -0.342724 5.51042 0.63639 3.34958L4.45515 7.18049C6.31561 9.04688 9.15526 6.19826 7.29479 4.33181L3.47603 0.599265C5.63013 -0.481329 8.2739 -0.0884023 10.0363 1.67986C11.7009 3.44794 12.1904 5.90364 11.4071 7.96658L11.4068 7.96635ZM0.929787 25.7453L10.4275 16.2174L14.7357 20.5393L5.23798 30.0672C2.39834 32.9159 -1.90974 28.5937 0.929787 25.7453ZM17.4774 11.5025L22.5691 6.39458L25.1149 2.36723L28.8356 0.107916L30.7939 1.97431L28.444 5.80522L24.5274 8.26097L19.3378 13.467L17.4774 11.5025Z",
    fill: "#436062"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketSettings);
export default __webpack_public_path__ + "static/media/TicketSettings.b9f509c0cbe07a1a33423175f40ff5d0.svg";
export { ForwardRef as ReactComponent };